export default __webpack_public_path__ + "static/media/banner-financial.ead29144.jpg";